export enum BannerType {
  ParentFloatingBanner = 'ParentFloatingBanner',
  FloatingBanner = 'FloatingBanner',
  LeftnavSkyscraper = 'LeftnavSkyscraper',
  RichTextMain = 'RichTextMain',
  DeeplinkBanner = 'DeeplinkBanner',
}
